import React from 'react';
import { useLanguage } from '../../i18n/LanguageContext';
import './pain-points.css';

const PainPoints = () => {
  const { t } = useLanguage();
  return (
    <section className="pain-points-area section-padding" id="pain">
      <div className="container">
        <div className="pain-section-header">
          <span className="section-label">{t.pain.label}</span>
          <h2 className="pain-section-heading">{t.pain.title}</h2>
        </div>
        <div className="pain-grid">
          {(t.pain?.items ?? []).map((item) => (
            <div className="pain-card" key={item}>
              <span className="pain-icon">⚠</span>
              <p>{item}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PainPoints;
